export function computeTaxFromValue(value: number): number {
  return Number((value * (0.22 / 1.22)).toFixed(2));
}
